<div class="container">
  <div class="heading_align">
    <div class="heading">Gebruiksvoorwaarden <span class="font_14 font_normal"> - voor Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>GELDIG VANAF: 25/04/2023</b></div>
        <div class="eula_points">
          De volgende Synappx™ Gebruiksvoorwaarden, evenals het <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Synappx Privacybeleid</b></a> hierin opgenomen door middel van
          verwijzing (gezamenlijk de "Overeenkomst"), is tussen Sharp Corporation ("Sharp") en de Klant. Deze
          Overeenkomst regelt de toegang tot en het gebruik van de Synappx, evenals alle Diensten die toegankelijk
          zijn via Synappx. In het kader van deze Overeenkomst wordt onder "Synappx" het volgende verstaan: Synappx Go, Synappx Admin Portal en gerelateerde Documentatie. Onder "Diensten" wordt verstaan: de Synappx
          Services, Specifieke Softwarediensten en alle gerelateerde Documentatie die eigendom kan zijn van Sharp
          en/of derde dienstverleners ("Derde Dienstverleners") en die toegankelijk zijn via de Synappx Service.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>GELDIG VANAF: 11 juli 2023</b></div>
        <div class="eula_points">
          De volgende Synappx™ Gebruiksvoorwaarden, evenals het <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Synappx Privacybeleid</b></a> hierin opgenomen door middel van
          verwijzing (gezamenlijk de "Overeenkomst"), is tussen Sharp Corporation ("Sharp") en de Klant. Deze
          Overeenkomst regelt de toegang tot en het gebruik van de Synappx, evenals alle Diensten die toegankelijk
          zijn via Synappx. In het kader van deze Overeenkomst wordt onder "Synappx" het volgende verstaan: Synappx Go, Synappx Cloud Print, Synappx Admin Portal en gerelateerde Documentatie. Onder "Diensten" wordt verstaan: de Synappx
          Services, Specifieke Softwarediensten en alle gerelateerde Documentatie die eigendom kan zijn van Sharp
          en/of derde dienstverleners ("Derde Dienstverleners") en die toegankelijk zijn via de Synappx Service.
        </div>
      </div>
    }
    <div class="eula_points">
      Het gebruik van de Diensten is bedoeld voor organisaties ("Klant") en hun Eindgebruiker(s). De term
      "Eindgebruiker(s)" en de variaties daarop betekent iedereen die toegang heeft tot de diensten die door
      Synappx Service worden geleverd. Eindgebruiker(s) kan/kunnen onder meer omvatten, maar is/zijn niet beperkt
      tot, medewerkers van de Klant, vertegenwoordigers, contractanten, agenten of elke andere persoon die de
      Diensten gebruikt of er toegang toe heeft onder een Klantenaccount en die door de Klant is geautoriseerd om
      de Diensten te gebruiken. Alle verwijzingen naar de term "Klant" verwijzen ook naar de bevoegde Beheerder(s)
      van de Klant en naar een van zijn Eindgebruikers, hetzij individueel, hetzij collectief.
    </div>
    <div class="eula_points">
      Voorafgaand aan elk gebruik en voordat toegang wordt verleend aan de Klant, moet(en) de geautoriseerde
      Beheerder(s) voor de Klant akkoord gaan met deze Overeenkomst namens de Klant. Door op "Akkoord" te klikken,
      verklaart en garandeert u, de Beheerder, dat: 1) u door de Klant bent aangewezen als "Beheerder" en het
      recht hebt op alle rechten en privileges die worden toegekend aan degenen die de rol van Beheerder vervullen
      (hieronder nader beschreven); 2) u bevoegd bent om de Klant aan deze Overeenkomst te binden. Als u niet bent
      aangewezen als Beheerder voor de Klant of niet over de hierboven vermelde bevoegdheid beschikt, dan mag u
      niet op "Akkoord" klikken en mag de Klant de Diensten niet gebruiken en er geen toegang toe krijgen. Nadat
      op "Akkoord" geklikt is, heeft de Klant het recht om de Diensten te gebruiken en er toegang toe te krijgen
      met inachtneming van de hierin opgenomen voorwaarden.
    </div>
    <div class="eula_points">
      Er kunnen andere specifieke softwarediensten ("Specifieke Softwarediensten") beschikbaar zijn binnen of via
      de Synappx Beheerdiensten die de Klant in staat stellen bepaalde functies uit te voeren of extra diensten en
      functies te gebruiken; deze Specifieke Softwarediensten zijn eigendom van Sharp en/of Derde Dienstverleners.
      De Klant begrijpt dat voor het gebruik van en/of de toegang tot deze Specifieke Softwarediensten van de
      Klant, Beheerder(s) en/of Eindgebruikers verlangd kan worden dat zij instemmen met aanvullende voorwaarden
      die van toepassing zijn op het gebruik van en/of de toegang tot de Specifieke Softwarediensten ("Aanvullende
      Voorwaarden"). Als de Klant, Beheerder(s) en/of Eindgebruikers niet akkoord gaan met dergelijke voorwaarden
      of als de Klant, Beheerder(s) en/of Eindgebruikers niet bevoegd zijn om akkoord te gaan met dergelijke
      Aanvullende Voorwaarden, dan mogen deze Specifieke Softwarediensten niet gebruikt worden of toegankelijk
      zijn voor de Klant, Beheerder(s) en/of Eindgebruikers, voor zover van toepassing. In het geval van enige
      inconsistentie tussen deze Overeenkomst en de Aanvullende Voorwaarden, zullen de Aanvullende Voorwaarden
      prevaleren, maar alleen voor de betreffende Specifieke Softwaredienst.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definities</b> <br />
        Naast alle hierboven gedefinieerde termen zijn de volgende definities van toepassing op deze
        Overeenkomst:
        <ol>
          <li> <b>Klantenaccount:</b> Verwijst naar alle accounts onder of toegewezen
          aan een Klant. Dit omvat alle van toepassing zijnde Beheerdersaccounts, alsmede alle Diensten
          waarvoor een licentie is verleend en alle informatie, gegevens, geassocieerd met de Klant,
        Beheerder(s) en zijn Eindgebruikers.</li>
        <li> <b>Beheerders:</b> De medewerker(s) die door de klant is/zijn
        aangewezen om de informatie en gegevens met betrekking tot de klantaccount te beheren, alsmede
      de toegang tot en de licenties voor de diensten ten behoeve van de klant.</li>
      <li> <b>Beheerdersaccount:</b> Dit verwijst naar het account van de
    beheerder.</li>
    <li> <b>Klantgegevens:</b> Alle gegevens en informatie die zijn opgeslagen,
    verzonden, verwerkt of geopend via de Diensten door de Klant, de Beheerder(s) en/of zijn
  Eindgebruikers of die zijn gekoppeld aan een Klantenaccount.</li>
  <li> <b>Dealer:</b> De geautoriseerde wederverkoper van de Diensten aan de
  Klant; de Dealer kan Sharp zijn, zijn dochtermaatschappij of de directe dealerfilialen van zijn
  dochtermaatschappij (in het geval van directe verkoop aan een Klant) of een geautoriseerde derde
  wederverkoper van Sharp-producten en -diensten. De Dealer is ook het belangrijkste aanspreekpunt
  voor de Klant voor ondersteuningsvragen met betrekking tot de Diensten. De Dealer kan diensten
voor de Klant verrichten op grond van een overeenkomst met de Klant en/of de Beheerder.</li>
<li> <b>Documentatie:</b> Alle installatie- en gebruikershandleidingen,
helpbestanden, FAQ's met betrekking tot de toegang tot of het gebruik van de Diensten.</li>
<li> <b>Intellectuele Eigendomsrechten:</b> Alle huidige of toekomstige
wereldwijde rechten onder patent, auteursrecht, handelsgeheim, handelsmerk, morele rechten en
andere intellectuele eigendomsrechten.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Gebruik door de Klant en Verantwoordelijkheden van de Klant </b>
  <ol>
    <li> De Klant is verantwoordelijk voor het aanwijzen van de persoon/personen die bevoegd is/zijn om
      namens de Klant de rol van Beheerder op zich te nemen. De Klant kan Beheerdersaccounts toewijzen
    en opnieuw toewijzen.</li>
    <li> De Klant is verantwoordelijk voor: het beheren van de toegang tot Beheerdersaccounts en het
      verzekeren van de toegang tot en/of het gebruik van de Diensten door de Klant, Beheerder(s) en
      Eindgebruikers in overeenstemming met deze Overeenkomst, Aanvullende Voorwaarden en alle
      toepasselijke Documentatie. Sharp en de Dealer zijn niet verantwoordelijk voor het interne
    beheer, de administratie of het gebruik van de Diensten namens de Klant.</li>
    <li> De Klant begrijpt en gaat ermee akkoord dat de Beheerder(s) en de Eindgebruikers worden
      beheerst door en zich zullen houden aan deze Overeenkomst, de Aanvullende Voorwaarden, de
      Documentatie en alle toepasselijke wetten, regels en voorschriften met betrekking tot het
      gebruik van de Diensten. De Klant is als enige verantwoordelijk voor alle handelingen of
      nalatigheden van de Klant, zijn Beheerder(s) en Eindgebruikers of voor niet-naleving van de
      voorwaarden van deze Overeenkomst, Aanvullende voorwaarden, Documentatie of enige toepasselijke
      wetten, regels en voorschriften met betrekking tot het gebruik van de Diensten. Deze
      verantwoordelijkheid strekt zich uit tot alle activiteiten onder een Klantenaccount, ongeacht of
      de activiteiten worden uitgevoerd door de Klant, diens medewerkers of een derde partij (met
      inbegrip van, maar niet beperkt tot, contractanten, vertegenwoordigers of agenten van de Klant).
    </li>
    <li> De Klant is er verantwoordelijk voor dat de Beheerder(s) en de Eindgebruikers voldoen aan alle
      van toepassing zijnde verplichtingen inzake werkgelegenheid, voorwaarden en het beleid van de
    Klant als zodanig met betrekking tot de toegang tot en het gebruik van de Diensten.</li>
    <li> De Klant stemt ermee in alle van toepassing zijnde toestemmingen van Eindgebruikers te
      beveiligen en te onderhouden om te zorgen dat Beheerders alle in deze Overeenkomst beschreven
      activiteiten kunnen uitvoeren en om Sharp en/of Derde Dienstverleners in staat te stellen de
    Diensten te leveren.</li>
    <li> Het is de verantwoordelijkheid van de Klant om onbevoegde toegang en/of onbevoegd gebruik maken
      van de Diensten door de Klant, de Beheerder(s) en de Eindgebruikers en eventuele derden te
      voorkomen. De Klant brengt Sharp en de Dealer onmiddellijk op de hoogte van elke onbevoegde
      toegang en/of onbevoegd gebruik van de Diensten. Sharp en de Dealer zijn niet verantwoordelijk
    voor onbevoegd gebruik van of onbevoegde toegang tot Klantenaccounts.</li>
    <li> De Klant gebruikt de Diensten uitsluitend voor zijn eigen interne bedrijfsvoering, en niet voor
      de exploitatie van een servicebureau of timesharingdienst. De Klant zal de Diensten niet bewust
      of opzettelijk gebruiken of toestaan dat de Diensten worden gebruikt op een manier die de
      levering van de Diensten zou kunnen beschadigen, uitschakelen, overbelasten, aantasten of op een
      andere manier verstoren. Dit omvat, maar is niet beperkt tot, het gebruik van de Diensten om
      virussen of corrupte bestanden over te brengen die de integriteit en veiligheid van de Diensten
    op enigerlei wijze zouden kunnen aantasten.</li>
    <li> De Klant zal niet en zal ervoor zorgen dat zijn Beheerder(s) of Eindgebruikers het volgende
      niet doen, direct of indirect: (a) de broncode, objectcode of onderliggende structuur, ideeën of
      algoritmen van de Diensten of enige software, Documentatie of gegevens met betrekking tot of
      geleverd met of via de Diensten te ontdekken via reverse-engineeren, decompileren, uit elkaar
      halen of op andere wijze; (b) de Diensten wijzigen, vertalen of afgeleide werken op basis van de
      Diensten creëren; of rechten in of op de Diensten te kopiëren (behalve voor archiefdoeleinden),
      verhuren, in lease geven, distribueren, verkopen, doorverkopen, in pand geven, overdragen of
      anderszins overdragen of bezwaren; (c) gebruik van of toegang tot de Diensten om te bouwen of te
      ondersteunen, en/of het bijstaan van een derde partij bij het bouwen of ondersteunen van
      producten of diensten die concurrerend zijn met de Diensten; of (d) het verwijderen of wijzigen
    van eigendomskennisgevingen of labels van de Diensten.</li>
    <li> De klant zal verder het volgende niet doen en zal ervoor zorgen dat zijn Beheerder(s) of
      Eindgebruikers dit ook niet doen: (a) de Diensten gebruiken voor activiteiten waarbij het
      gebruik of het falen van de Diensten kan leiden tot fysieke schade, persoonlijk letsel of de
      dood; (b) de Diensten gebruiken of het gebruik van de Diensten toestaan voor illegale,
      frauduleuze, beledigende of schadelijke activiteiten; (c) de Diensten gebruiken op een manier
      die de levering van de Diensten kan beschadigen, uitschakelen, overbelasten, aantasten of
      anderszins verstoren, onder meer door het verzenden van virussen of corrupte bestanden; of (d)
      de Diensten gebruiken om de Intellectuele Eigendomsrechten of de eigendomsrechten van anderen te
    schenden of te misbruiken.</li>
    <li> De Klant begrijpt dat de Klant verantwoordelijk is voor de naleving van alle toepasselijke
      verticale of branchespecifieke regelgeving en dat Sharp, de Dealer en/of Derde Dienstverleners
    niet aansprakelijk zijn voor niet-naleving van deze regelgeving door de Klant.</li>
    <li> De Klant is als enige verantwoordelijk voor het verkrijgen en onderhouden van de juiste
      apparatuur en aanvullende diensten die nodig zijn om verbinding te maken met, toegang te krijgen
      tot, te voorzien in of anderszins gebruik te maken van de Diensten, met inbegrip van, maar niet
      beperkt tot, computers, computerbesturingssystemen en webbrowser(s), internettoegang, mobiele
      apparaten, multifunctionele randapparatuur ("MFP's"), beeldschermsystemen, andere elektronische
      apparaten en accessoires (gezamenlijk "Apparatuur" genoemd). De Klant zal ervoor zorgen dat de
      Apparatuur voldoet aan alle configuraties en specificaties die in de Documentatie, indien van
      toepassing, voor de Diensten zijn vermeld. De Documentatie met betrekking tot Specifieke
    Softwarediensten kan toegankelijk zijn via de Specifieke Softwarediensten.</li>
    <li> Als de Klant een abonnementsovereenkomst heeft met een Dealer of een Derde Dienstverlener met
      betrekking tot de Diensten of een deel van de Diensten, dan zorgt de Klant ervoor dat hij
      voldoet aan een dergelijke overeenkomst, met inbegrip van de betaling van alle toepasselijke
      vergoedingen, aangezien het niet nakomen daarvan kan leiden tot opschorting of beëindiging van
    de Klantenaccount of toegang tot en gebruik van de Diensten of een deel van de Diensten.</li>
    <li> Als de Klant een geldige dagvaarding, een gerechtelijk bevel of een ander verzoek ontvangt met
      betrekking tot de Diensten, een Klantenaccount of Klantgegevens, dan is de Klant
      verantwoordelijk voor het beantwoorden van dergelijke verzoeken via toegang tot zijn eigen
      Klantgegevens. Als de Klant geen toegang kan krijgen tot de gevraagde Klantgegevens of andere
      opgevraagde informatie, dan neemt de Klant contact op met Sharp voor ondersteuning. Sharp levert
      commercieel gezien redelijke inspanningen leveren om de Klant in dit opzicht bij te staan. Als
      de Klant niet tijdig reageert, dan kan Sharp op een dergelijk verzoek van een derde partij
      reageren, maar Sharp is dan niet verplicht te reageren. Als Sharp, de Dealer en/of een Derde
      Dienstverlener een geldige dagvaarding, gerechtelijk bevel of ander verzoek ontvangt met
      betrekking tot de Diensten, een Klantenaccount of Klantgegevens, met inbegrip van, maar niet
      beperkt tot, Beheerdersaccounts of gegevens binnen de Klantenaccount, dan zal Sharp, de Dealer
      en/of een Derde Dienstverlener voldoen aan de dagvaarding, het gerechtelijk bevel of het verzoek
      zoals vereist door de toepasselijke wetgeving. Aanvullende informatie met betrekking tot het
      gebruik van of de mogelijk noodzakelijke toegang tot Klantenaccounts door Sharp is uiteengezet
      in het <a tabindex="-1" class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx
    Privacybeleid</b></a>.</li>
    <li> De Klant is verantwoordelijk voor elke inbreuk op deze sectie door de Klant, met inbegrip van
      een van zijn Beheerder(s) of Eindgebruikers. De Klant erkent en begrijpt dat Sharp, de Dealer en
      Derde Dienstverleners niet aansprakelijk zijn jegens de Klant of anderszins voor enige actie die
    een Eindgebruiker onderneemt.</li>
  </ol>
</div>
<div class="eula_points">
  <b>C. De Rol van de Beheerder</b>
  <ol>
    <li> Alle Beheerders dienen de Diensten te gebruiken in overeenstemming met deze Overeenkomst,
      Aanvullende Voorwaarden, Documentatie, indien van toepassing, alle verplichtingen inzake
      werkgelegenheid en voorwaarden en het beleid van de Klant, alsmede alle wetten, regels en
    voorschriften die van toepassing zijn op de toegang tot en/of het gebruik van de Diensten.</li>
    <li> De Beheerder begrijpt dat de Klant Beheerdersaccounts kan toewijzen en opnieuw kan toewijzen.
    </li>
    <li> Met behulp van de Synappx Beheerdersaccount houdt een Beheerder controle over de Klantenaccount
      door de Klantenaccount te beheren, met inbegrip van eventuele licenties (individueel of
    gebundeld) die aan de Klantenaccount zijn gekoppeld.</li>
    <li> De Beheerder kan de toegang tot alle Klantenaccounts instellen, toegang verlenen tot de
      Klantenaccounts, de Klantenaccounts bewaken, beperken en opschorten en toegang tot de
      Klantenaccounts beëindigen, met inbegrip van aanvullende Beheerdersaccounts, Werkruimtelicenties
    of Eindgebruikerlicenties.</li>
    <li> De Beheerder(s) kan/kunnen ook een Eindgebruiker zijn. In dat geval zijn alle voorwaarden in
      deze Overeenkomst of Aanvullende Voorwaarden met betrekking tot een Eindgebruiker ook van
    toepassing op de Beheerder in zijn hoedanigheid van Eindgebruiker.</li>
  </ol>
</div>
<div class="eula_points">
  <b>D. Gebruik door de Eindgebruiker</b>
  <ol>
    <li> De Klant zorgt ervoor dat Eindgebruikers de Diensten gebruiken in overeenstemming met deze
      Overeenkomst, Aanvullende Voorwaarden, Documentatie, indien van toepassing, alle verplichtingen
      inzake werkgelegenheid en voorwaarden en het beleid van de Klant, alsmede alle wetten, regels en
    voorschriften die van toepassing zijn op de toegang tot en/of het gebruik van de Diensten.</li>
    <li> De Klant is verantwoordelijk voor de toegang tot en het gebruik van de Diensten door de
    Eindgebruikers.</li>
    <li> Een Eindgebruiker mag zijn of haar activiteiten in de Diensten niet loskoppelen van de Klant.
    </li>
    <li> De Klant verklaart en garandeert dat: (a) de Eindgebruiker alle rechten en licenties heeft om
      toegang te krijgen tot en gebruik te maken van de Diensten; en (b) dat de opslag, verzending en
      verwerking van informatie met betrekking tot en de toegang van de Eindgebruiker tot de Diensten
      niet in strijd is met de voorwaarden van deze Overeenkomst, Aanvullende Voorwaarden, relevante
      Documentatie, de Intellectuele Eigendomsrechten of eigendomsrechten van anderen, of met de
    toepasselijke wetten, regels of voorschriften.</li>
    <li> De Klant erkent dat hij als enige verantwoordelijk is voor de aard, kwaliteit en nauwkeurigheid
    van elke activiteit van de Eindgebruiker in verband met Diensten.</li>
  </ol>
</div>
<div class="eula_points">
  <b>E. De Rol van de Dealer</b>
  <ol>
    <li> De Dealer is verantwoordelijk voor het aanmaken van een Klantenaccount en het verstrekken van
      licenties voor Diensten aan de Beheerder(s). Zodra er een Beheerder voor een Klant is
      aangemaakt, heeft de Dealer geen mogelijkheid meer hebben om Beheerdersaccounts aan te maken.
    </li>
    <li> Dealers kunnen licenties voor Klantenaccounts beheren, met inbegrip van het aankopen of het
      stopzetten van een licentie. Een Dealer kan een reeds aan een Beheerder verstrekte licentie die
    niet beëindigen, tenzij uitdrukkelijk anders is bepaald in deze Overeenkomst.</li>
    <li> Dealers hebben toegang tot basisinformatie over de Klantenaccounts, evenals de naam, het adres,
      de telefoonnummers en de namen en e-mailadressen van alle Beheerders. Dealers hebben eveneens
    toegang tot en kunnen alle Klantenaccountlicenties voor Diensten te bekijken.</li>
    <li> Dealers kunnen de toegang van een Klant tot het Klantenaccount opschorten en/of annuleren.</li>
    <li> Als uw Dealer niet of niet langer bevoegd is om een Klantenaccount te onderhouden, dan kan
      Sharp of zijn dochtermaatschappij de Klantenaccount naar eigen goeddunken overdragen aan
      een andere Dealer. Een Dealer kan een Klantenaccount niet op eigen initiatief overdragen aan een
    andere Dealer.</li>
    <li>. De Dealer kan op verzoek van de Klant de Diensten als Eindgebruiker gebruiken.</li>
  </ol>
</div>
<div class="eula_points"><b>F. Diensten</b>
<ol>
  <li> Klanten kunnen alleen toegang krijgen tot en gebruik maken van de Diensten in overeenstemming
    met de voorwaarden van deze Overeenkomst, Aanvullende voorwaarden, Documentatie en eventuele
    aanvullende gebruiksvoorwaarden of privacybeleid die van toepassing zijn op de toegang tot en/of
    het gebruik van de Diensten. Niet-naleving van deze Overeenkomst, Aanvullende Voorwaarden,
    Documentatie en alle toepasselijke wetten, regels of voorschriften door de Klant kan ertoe
    leiden dat dit Klanten- of Beheerdersaccount naar eigen goeddunken van Sharp wordt opgeschort of
  beëindigd.</li>
  <li> Diensten of delen daarvan kunnen onderworpen zijn aan abonnementsovereenkomsten met Dealers
    en/of Derde Dienstverleners; niet-naleving van dergelijke overeenkomsten door de Klant, met
    inbegrip van, maar niet beperkt tot, de betaling van alle toepasselijke vergoedingen, kan leiden
    tot de opschorting of beëindiging van het Klantenaccount of de toegang tot en het gebruik van de
  Diensten, of een deel daarvan, als gevolg van een dergelijke tekortkoming.</li>
  <li> De toegang tot en het gebruik van de Diensten hangt ook af van het feit of Sharp alle kosten
    van de Dealer voor de toegang tot en het gebruik van de Diensten door de Klant heeft ontvangen;
    in het geval dat Sharp, of zijn dochtermaatschappij, geen kosten heeft ontvangen die van
    toepassing zijn op uw Klantenaccount van uw Dealer, en een dergelijk verzuim niet wordt
    verholpen binnen dertig (30) dagen na schriftelijke kennisgeving daarvan; dan kan Sharp of zijn
    dochtermaatschappij naar eigen goeddunken uw Klantenaccount opschorten of beëindigen totdat
  Sharp of zijn dochtermaatschappij dergelijke verschuldigde betalingen heeft ontvangen.</li>
  <li> Sharp levert commercieel gezien redelijke inspanningen om ervoor te zorgen dat alle
    faciliteiten die worden gebruikt om Klantgegevens op te slaan en te verwerken, voldoen aan
    commercieel gezien redelijke veiligheidsnormen. Door gebruik te maken van de Diensten stemt de
  Klant in met de doorgifte, verwerking en opslag van Klantgegevens door Sharp.</li>
  <li> De Klant begrijpt dat Sharp en/of Derde Dienstverleners de Diensten van tijd tot tijd kunnen
  bijwerken met of zonder kennisgeving aan de Klant.</li>
  <li> Niettegenstaande eventuele andersluidende bepalingen: als er wordt vastgesteld dat
    Klantgegevens deze Overeenkomst schenden of kunnen schenden of op enigerlei wijze afbreuk doen
    aan de Diensten, de Diensten overbelasten of bedreigen of schade toebrengen aan de Diensten, dan
    kunnen dergelijke Klantgegevens naar eigen goeddunken van Sharp geheel of gedeeltelijk worden
    verwijderd, met of zonder kennisgeving aan de Klant en zonder dat Sharp daarvoor aansprakelijk
    kan worden gesteld. De Klant is verantwoordelijk voor het maken van een back-up van de
  klantgegevens in het geval van een dergelijke verwijdering.</li>
  <li> Aanvullende voorwaarden met betrekking tot privacy, verwerking en opslag van Klantgegevens,
    alsmede toegang tot Klantgegevens zijn opgenomen in het <a tabindex="-1" class="text_underline"
    [href]="privacyUrl" target="_blank"><b>Synappx Privacybeleid</b></a> en in de van toepassing
  zijnde Documentatie voor de Diensten.</li>
</ol>
</div>
<div class="eula_points"><b>G. Ondersteuning</b>
<ol>
  <li> Het is de verantwoordelijkheid van de Klant om contact op te nemen met de Dealer voor alle
    ondersteuningskwesties met betrekking tot de Diensten die niet in behandeling kunnen worden
  genomen via de Documentatie voor Specifieke Softwarediensten.</li>
  <li> Tenzij Sharp of een Sharp-dealerfiliaal de Dealer is voor uw Klantenaccount, is Sharp niet
    verantwoordelijk tegenover de Klant voor vragen met betrekking tot of ondersteuning van de
  Diensten boven hetgeen wordt geleverd via de Documentatie voor Specifieke Softwarediensten.</li>
</ol>
</div>
<div class="eula_points"><b>H. Intellectueel Eigendom</b>
<ol>
  <li> Deze Overeenkomst verleent Sharp, Dealer of een Derde Dienstverlener geen rechten op
    Klantgegevens of de intellectuele eigendomsrechten die zijn belichaamd in een Klantenaccount,
    Beheerdersaccount, met uitzondering van de beperkte rechten die uitdrukkelijk zijn uiteengezet
    in deze Overeenkomst of Aanvullende Voorwaarden of die anderszins nodig zijn om de Diensten te
  verlenen en de Klant in staat te stellen de Diensten te gebruiken.</li>
  <li> Tenzij specifiek anders vermeld in deze Overeenkomst of de Aanvullende Voorwaarden wordt geen
    van de volgende zaken aan de Klant, Beheerder(s) of enige Eindgebruiker toegekend: (a)
    Intellectuele Eigendomsrechten in of op de Diensten of een deel daarvan; (b) Intellectuele
    Eigendomsrechten in of op andere Klantenaccounts; of (c) rechten op het gebruik van de logo's,
    handelsmerken, servicemerken, domeinnamen of merkeigenschappen van Sharp, de Dealer, Derde
  Dienstverleners, de Diensten of een onderdeel van de Diensten.</li>
  <li> Voor zover Sharp van de Klant, Beheerder(s) of een Eindgebruiker het verzoek krijgt voor het
    verrichten van bepaalde handelingen met inbegrip van, maar niet beperkt tot, het verzenden,
    hosten of delen van bestanden, het gebruik van of het verlenen van toegang tot productfuncties
    of -instellingen, dan verleent de Klant Sharp de toestemming om alle handelingen te verrichten
    die nodig zijn voor Sharp of de Dealer om de Diensten en de functionaliteit te leveren die
    beschikbaar zijn via de Diensten en die in de Documentatie zijn beschreven. Deze toestemming
    strekt zich uit tot alle diensten van Derde Dienstverleners waarvan Sharp gebruikt maakt om de
  Diensten te leveren.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Disclaimers</b></div>
  <div class="eula_point_left">SHARP LEVERT COMMERCIEEL GEZIEN REDELIJKE INSPANNINGEN OM DE DIENSTEN
    BESCHIKBAAR TE STELLEN VOOR HET GEBRUIK DOOR EN DE TOEGANG VAN DE KLANT IN OVEREENSTEMMING MET DEZE
    OVEREENKOMST, AANVULLENDE VOORWAARDEN EN ALLE VAN TOEPASSING ZIJNDE DOCUMENTATIE. NIETTEGENSTAANDE
    EVENTUELE ANDERSLUIDENDE BEPALINGEN WORDEN DE DIENSTEN GELEVERD "ZOALS ZE ZIJN". VOOR ZOVER
    TOEGESTAAN DOOR DE WET, BEHALVE ZOALS UITDRUKKELIJK VERMELD IN DIT DOCUMENT, GEEFT SHARP GEEN ENKELE
    GARANTIE NAMENS ZICHZELF, DE DEALER OF EEN DERDE DIENSTVERLENER, EXPLICIET, IMPLICIET OF ANDERSZINS,
    MET INBEGRIP VAN GARANTIES DAT DE DIENST ONONDERBROKEN EN VRIJ VAN FOUTEN ZAL ZIJN, GARANTIES DAT DE
    INHOUD VEILIG ZAL ZIJN OF NIET ANDERSZINS VERLOREN ZAL GAAN OF BESCHADIGD ZAL WORDEN, GARANTIES DAT
    DEFECTEN ZULLEN WORDEN GECORRIGEERD, OF GARANTIES VAN VERKOOPBAARHEID, GESCHIKTHEID VOOR EEN BEPAALD
    GEBRUIK OF NIET-INBREUK. SHARP DOET GEEN UITSPRAKEN OVER EENDER WELKE INHOUD, MET INBEGRIP VAN
    KLANTGEGEVENS IN OF VANUIT EEN KLANTENACCOUNT EN DE KLANT IS ALS ENIGE VERANTWOORDELIJK VOOR ALLE
  KLANTGEGEVENS EN DE TOEGANG TOT EN HET GEBRUIK VAN DE DIENSTEN.</div>
</div>

<div class="eula_points"><b>J. Duur en einde</b>
<ol>
  <li> Deze Overeenkomst blijft van kracht totdat de Klant niet langer een geldig abonnement of
    toegang tot de Diensten heeft, of totdat deze Overeenkomst wordt beëindigd in overeenstemming
    met de voorwaarden die in deze Overeenkomst zijn vastgelegd. De Klant begrijpt dat bepaalde
    Specifieke Softwarediensten sneller beëindigd kunnen worden in overeenstemming met de bepalingen
  van de toepasselijke Aanvullende Voorwaarden.</li>
  <li> De Dealer kan een Klantenaccount beëindigen als de Klant geen abonnementskosten betaalt die
    verschuldigd zijn aan de Dealer voor het gebruik van of de toegang tot de Diensten door de
  Klant.</li>
  <li> Sharp kan deze Overeenkomst en uw toegang tot en gebruik van de Diensten beëindigen als Sharp
    geen vergoedingen van de Dealer ontvangt voor het gebruik of de toegang tot de Dienst door de
    Klant en dit verzuim niet binnen dertig (30) dagen na schriftelijke kennisgeving daarvan wordt
    verholpen; een dergelijke opschorting of beëindiging kan van kracht blijven totdat Sharp de
  verschuldigde betalingen heeft ontvangen.</li>
  <li> Deze Overeenkomst en de toegang tot en het gebruik van de Diensten worden automatisch verlengd,
  tenzij de Klant de Dealer in kennis stelt van zijn voornemen om de Diensten te beëindigen.</li>
  <li> Bovendien kan Sharp of zijn dochtermaatschappij deze Overeenkomst beëindigen indien de Klant
    een wezenlijke voorwaarde van deze Overeenkomst schendt en de schending niet binnen dertig (30)
    dagen na ontvangst van een schriftelijke kennisgeving hiervan verhelpt; een dergelijke
    schriftelijke melding kan in de vorm van een e-mail of een andere elektronische kennisgeving
  verzonden worden.</li>
  <li> In het geval van beëindiging van deze Overeenkomst zullen de rechten die aan de Klant,
    Beheerder(s) en Eindgebruikers zijn toegekend onmiddellijk worden beëindigd, met dien verstande
    dat de Klantenaccount en Klantgegevens onder een Klantenaccount gedurende vijftien (15) dagen na
    de effectieve einddatum van het abonnement toegankelijk zullen zijn. Bij afloop of beëindiging
    van deze Overeenkomst om welke reden dan ook, behalve indien expliciet geautoriseerd op grond
    van deze Sectie, gaat de Klant ermee akkoord alle toegang tot en het gebruik van de Diensten
    onmiddellijk te beëindigen. De Klant erkent en gaat ermee akkoord dat Sharp en/of Derde
    Dienstverleners geen verplichting hebben om Klantgegevens te bewaren na de hierin genoemde
    periode van dertig (30) dagen en dat na deze periode van dertig (30) dagen alle Klantgegevens
  onherroepelijk gewist kunnen worden.</li>
  <li> Niettegenstaande de beëindiging of afloop van deze Overeenkomst blijft de Klant
    verantwoordelijk voor alle vergoedingen die aan de Dealer verschuldigd zijn krachtens uw
    overeenkomst met uw Dealer of die anderszins aan de Dealer verschuldigd zijn voor het gebruik
    van of de toegang tot de Diensten vóór de effectieve datum van beëindiging of afloop van deze
  Overeenkomst.</li>
  <li> Meldingen aan de Klant in het kader van deze sectie kunnen in de vorm van een e-mail of een
    andere elektronische kennisgeving gedaan worden en kunnen worden doorgestuurd naar de
  Beheerder(s).</li>
  <li> De volgende secties van deze Overeenkomst blijven ook van kracht na afloop of beëindiging van
    deze Overeenkomst om welke reden dan ook: Secties F(6), H, I, J(6) tot J(9), K, L, M, Q en S.
  </li>
  <li> De punten 1 tot 9 van dit artikel J (Duur en einde) zijn niet van toepassing voor Synappx
    Manage. Synappx Manage kan uw
    gratis gebruik op elk moment en om welke reden dan ook naar goeddunken van Sharp beëindigen,
    zonder aansprakelijkheid
  jegens u.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Schadeloosstelling</b></div>
  <div class="eula_point_left">De Klant zal Sharp, zijn Dealers, Derde Dienstverleners en elk van hun
    gelieerde ondernemingen, met inbegrip van maar niet beperkt tot moedermaatschappijen of
    dochterondernemingen, directeuren, functionarissen, medewerkers, agenten en contractanten
    (gezamenlijk "Sharp-partijen") vrijwaren, verdedigen en schadeloos stellen voor alle
    aansprakelijkheden, schade en kosten (met inbegrip van schikkingskosten en redelijke
    advocatenhonoraria) die voortvloeien uit een vordering van een derde partij met betrekking tot het
    volgende: (a) gebruik van de Diensten door de Klant; (b) alle Klantgegevens; (c) elke inbreuk of
    schending van deze Overeenkomst door de Klant, Beheerder(s) en/of een Eindgebruiker; en (d) elke
    inbreuk of vermeende inbreuk op enige toepasselijke wet- of regelgeving die van toepassing is op de
    Klant, Beheerder en/of een Eindgebruiker met betrekking tot de Diensten. Sharp onderneemt
    commercieel gezien redelijke stappen om de Klant op de hoogte te stellen van een dergelijke claim of
  eis waarop deze sectie betrekking heeft.</div>
</div>

<div class="eula_point">
  <div><b>L. Beperking van aansprakelijkheid</b></div>
  <div class="eula_point_left">VOOR ZOVER WETTELIJK TOEGESTAAN ZIJN DE SHARP-PARTIJEN IN GEEN GEVAL
    AANSPRAKELIJK JEGENS DE KLANT, BEHEERDER(S), EINDGEBRUIKERS OF DERDEN VOOR DIRECTE, BIJZONDERE,
    INCIDENTELE, INDIRECTE, PUNITIEVE SCHADE OF GEVOLGSCHADE, MET INBEGRIP VAN, MAAR NIET BEPERKT TOT,
    WINSTDERVING, VERLIES VAN GEGEVENS, VERLIES VAN GEBRUIK OF VERLIES VAN INHOUD OF ANDERE SCHADE DIE
    VOORTVLOEIT UIT OF VERBAND HOUDT MET DEZE OVEREENKOMST, AANVULLENDE VOORWAARDEN, DE DIENSTEN, HET
    KLANTENACCOUNT OF KLANTGEGEVENS. DEZE PARAGRAAF IS VAN TOEPASSING ONGEACHT OF HET VERMOEDEN VAN
    AANSPRAKELIJKHEID GEBASEERD IS OP EEN CONTRACT, EEN ONRECHTMATIGE DAAD, NALATIGHEID, SCHENDING VAN
    DE GARANTIE, RISICOAANSPRAKELIJKHEID OF ANDERSZINS EN ONGEACHT OF DE SHARP-PARTIJEN AL DAN NIET OP
    DE HOOGTE ZIJN GESTELD VAN DE MOGELIJKHEID VAN DERGELIJKE SCHADE. IN GEEN GEVAL ZAL DE CUMULATIEVE
    AANSPRAKELIJKHEID VAN DE SHARP-PARTIJEN JEGENS DE KLANT OF EEN DERDE PARTIJ GROTER ZIJN DAN EEN
    BEDRAG DAT GELIJK IS AAN DRIE MAANDEN VAN UW SERVICEKOSTEN. U ONTSLAAT DE SHARP-PARTIJEN HIERBIJ VAN
    ALLE VERPLICHTINGEN, AANSPRAKELIJKHEDEN EN VORDERINGEN BOVEN DEZE BEPERKING. DEZE BEPERKING VAN DE
    AANSPRAKELIJKHEID BLIJFT OOK NA AFLOOP OF BEËINDIGING VAN DEZE OVEREENKOMST, OM WELKE REDEN DAN OOK,
    VAN KRACHT, ZELFS INDIEN EEN BEPERKTE VERHAALSMOGELIJKHEID, ZOALS GESPECIFICEERD IN DEZE SECTIE,
  FAALT IN HAAR WEZENLIJKE DOEL.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Geldend recht/afstand van het recht op juryrechtspraak</b></div>
  <div class="eula_point_left">Indien de Klant de Diensten uitsluitend voor persoonlijke, niet-zakelijke
    doeleinden gebruikt, dan is op deze
    Overeenkomst de wetgeving van toepassing van het rechtsgebied waarin de Klant de licentie voor het
    gebruik van de
  Diensten heeft gekocht of verkregen.</div>
  <div class="eula_point_left">Indien de Klant niet een dergelijke consument is, dan wordt deze
    Overeenkomst beheerst door en geïnterpreteerd in
  overeenstemming met het materiële recht dat van kracht is in:</div>
  <ol>
    <li>
      de staat New York, indien een licentie voor het gebruik van de Diensten is gekocht of verkregen
      wanneer de Klant zich in
      de Verenigde Staten, Canada of Mexico bevindt;
    </li>
    <li>Engeland en Wales, indien een licentie voor het gebruik van de Diensten is gekocht of verkregen
      wanneer de Klant zich in
    het Verenigd Koninkrijk of in een EER-land bevindt;</li>
    <li>het land van de Europese Unie waar de Klant zich bevindt, indien een licentie voor het gebruik
      van de Diensten door de
    Klant in dat land van de Europese Unie is gekocht of verkregen;</li>
    <li>Japan, indien een licentie voor het gebruik van de Diensten is gekocht of verkregen wanneer de
      Klant zich in een
    rechtsgebied bevindt dat hierboven niet is beschreven;</li>
  </ol>
  <div class="eula_point_left">De respectievelijke bevoegde rechtbanken van:</div>
  <ol>
    <li>
      New York County, New York wanneer de wet van de staat New York van toepassing is;
    </li>
    <li>
      Engeland en Wales, wanneer het recht van Engeland en Wales van toepassing is;
    </li>
    <li>
      het land van de Europese Unie waar de Klant zich bevindt wanneer het recht van dat land van de
      Europese Unie van
      toepassing is;
    </li>
    <li> De districtsrechtbank van Osaka in Japan, wanneer Japans recht van toepassing is
    </li>
    hebben elk een niet-exclusieve jurisdictie over alle geschillen in verband met deze
    Overeenkomst.
  </ol>
  <div class="eula_point_left">Alle vorderingen op grond van deze Overeenkomst tegen Sharp-Partijen moeten
    binnen één (1) jaar na het ontstaan van de
    oorzaak van de vordering worden ingesteld of de vordering of de oorzaak van de vordering wordt
    uitgesloten. De Klant en
    Sharp doen hierbij afstand van het recht op juryrechtspraak met betrekking tot enig geschil met
    betrekking tot deze
  Overeenkomst of de Diensten.</div>
</div>

<div class="eula_point">
  <div><b>N. Handelsmerken</b></div>
  <div class="eula_point_left">De handelsmerken of servicemerken "SHARP", "Synappx", "Synappx Meeting",
    "Synappx Go", of enige andere gerelateerde productnamen, servicenamen of logo's die worden gebruikt,
    geciteerd en/of waarnaar wordt verwezen op of via de Diensten zijn handelsmerken, geregistreerde
    handelsmerken of servicemerken van Sharp en/of zijn gelieerde entiteiten. Alle andere productnamen,
    dienstnamen, logo's en/of bedrijfsnamen die op of via de Diensten verschijnen, zijn het eigendom van
    hun respectievelijke houders en kunnen beschermd worden als hun handelsmerken, geregistreerde
  handelsmerken, dienstmerken en/of handelsnamen.</div>
</div>

<div class="eula_point">
  <div><b>O. Overmacht</b></div>
  <div class="eula_point_left">De Sharp-Partijen, Derde Dienstverleners en de Klant zijn niet
    aansprakelijk voor ontoereikende prestaties voor zover deze worden veroorzaakt door een toestand die
    buiten de redelijke controle van de betreffende partij valt, met inbegrip van, maar niet beperkt
    tot, natuurrampen, oorlogshandelingen, terrorisme of vijandigheden, rellen, overheidsmaatregelen,
    arbeidsomstandigheden of elektrische verstoringen of defecten, alsmede verstoringen of defecten op
    het gebied van telecommunicatie of Internet. Sharp en de Klant gaan ermee akkoord redelijke
  inspanningen te leveren om de gevolgen van een geval van overmacht te beperken.</div>
</div>

<div class="eula_point">
  <div><b>P. Export</b></div>
  <div class="eula_point_left">De Klant gaat ermee akkoord dat de lokale wetten inzake exportcontrole (van
    het land van gebruik van de Diensten) uw gebruik van de Diensten (met inbegrip van technische
    gegevens) en alle te leveren producten van de toegang tot en het gebruik van de Diensten regelen.
    Voorts stemt de Klant ermee in om te voldoen aan al deze exportwetten en -voorschriften (met
    inbegrip van voorschriften op het gebied van "gelijkgesteld met uitvoer" en "gelijkgesteld met
    wederuitvoer"). De Klant gaat ermee akkoord dat geen gegevens, informatie, softwareprogramma's en/of
    materialen voortvloeiend uit de Diensten (of het directe product daarvan) uitgevoerd zullen worden,
    direct of indirect, in strijd met deze wetten, of gebruikt zullen worden voor enig doel dat verboden
    is door deze wetten, met inbegrip van, maar niet beperkt tot tot het verspreiden van nucleaire,
  chemische of biologische wapens, of de ontwikkeling van rakettechnologie.</div>
</div>

<div class="eula_point">
  <div><b>Q. Statistische informatie</b></div>
  <div class="eula_point_left">Niettegenstaande iets anders in deze Overeenkomst of anderszins, kan Sharp
    het gebruik van de Diensten door de Klant controleren en de Klantgegevens op een geaggregeerde en
    anonieme manier gebruiken, statistische informatie en informatie over het gebruik en de prestaties
    met betrekking tot de levering en de werking van de Diensten verzamelen en deze informatie openbaar
    maken ("Geaggregeerde Gegevens"), op voorwaarde dat deze Geaggregeerde Gegevens de Klant niet
    identificeren en de Klantgegevens niet onthullen. Sharp behoudt alle Intellectuele Eigendomsrechten
  op dergelijke Geaggregeerde Gegevens.</div>
</div>

<div class="eula_points"><b>R. Wijzigingen in de Voorwaarden</b>
<ol>
  <li> Sharp kan de voorwaarden van deze Overeenkomst van tijd tot tijd naar eigen goeddunken herzien
    of wijzigen. Als deze voorwaarden herzien of gewijzigd worden, dan dient /dienen de Beheerder(s)
    de herziene of gewijzigde voorwaarden te aanvaarden bij de eerstvolgende aanmelding na de datum
    waarop de herziening of wijziging van kracht wordt. De huidige versie van deze Overeenkomst
    wordt geplaatst op <a tabindex="-1" class="text_underline" [href]="termsUseUrl"
  target="_blank">Synappx-ondersteuningssite</a> en het is de verantwoordelijkheid van de
  Klant om deze site regelmatig te controleren. Sharp levert redelijke inspanningen leveren om
  dertig (30) dagen vóór de ingangsdatum van een wijziging een kennisgeving te doen, maar sommige
wijzigingen kunnen minder dan dertig (30) dagen voor de ingangsdatum van kracht worden.</li>
<li> Als de Klant de Diensten blijft gebruiken na de ingangsdatum van de herziene of gewijzigde
  Overeenkomst, dan gaat de Klant ermee akkoord dat hij/zij, zijn/haar Beheerder(s) en zijn/haar
  Eindgebruikers daarna gebonden zijn aan de nieuwe voorwaarden. Als de Klant niet akkoord gaat
  met de herziene voorwaarden van de Overeenkomst, dan kan de Klant ervoor kiezen de toegang tot
en het gebruik van de Diensten te staken.</li>
</ol>
</div>
<div class="eula_points"><b>S. Aanvullende Voorwaarden</b>
<ol>
  <li> De Klant gaat ermee akkoord dat er geen partnerschap, joint venture of agentschapsrelatie
  bestaat tussen Sharp en de Klant.</li>
  <li> Tenzij de Klant Sharp specifiek schriftelijk iets anders te kennen geeft, mag Sharp de naam van
    de Klant opnemen in een lijst van klanten op de marketingmaterialen van Sharp, inclusief
  websites.</li>
  <li> Tenzij anders vermeld in deze Overeenkomst, zullen algemene kennisgevingen van Sharp aan de
    Klant of Eindgebruikers met betrekking tot deze Overeenkomst of de Diensten worden geplaatst op
    de <a tabindex="-1" class="text_underline" [href]="supportType"
  target="_blank">Synappx-ondersteuningssite</a>. Om deze reden dienen de Klant en
  Eindgebruikers dit Privacybeleid regelmatig de <a tabindex="-1" class="text_underline"
[href]="supportType" target="_blank">Synappx-ondersteuningssite</a> te bezoeken om op de
hoogte te zijn van dergelijke kennisgevingen. Specifieke kennisgevingen met betrekking tot
Diensten worden verzonden naar het geregistreerde e-mailadres van de Beheerder. Alle
kennisgevingen, met inbegrip van juridische kennisgevingen, vragen of opmerkingen met betrekking
tot deze Overeenkomst dienen te worden gericht aan: <br>
<span>Synappx Product Manager</span>
<div>Sharp Corporation </div>
<div>492 Minosho-cho, Yamato-Koriyama City, </div>
<div>Nara 639-1186, Japan</div>
</li>
<li> De Klant mag geen enkel onderdeel van deze Overeenkomst overdragen of afstaan zonder de
  voorafgaande schriftelijke toestemming van Sharp. Sharp kan deze Overeenkomst toewijzen na
  kennisgeving aan de Klant. Deze kennisgeving kan de vorm hebben van een e-mail, verzonden worden
  via de reguliere post of in de vorm van een bericht via de Diensten. Niettegenstaande eventuele
  andersluidende bepalingen kan Sharp deze Overeenkomst zonder enige kennisgeving aan de Klant
  overdragen aan een gelieerde entiteit of in verband met een fusie, overname,
bedrijfsreorganisatie of verkoop van alle of vrijwel alle activa.</li>
<li> Het feit dat Sharp afstand doet van enige inbreuk of recht uit hoofde van deze Overeenkomst
  wordt niet beschouwd als een verklaring van afstand van enige andere of latere inbreuk of recht.
</li>
<li> Als een bepaling van deze Overeenkomst (of een deel daarvan) onafdwingbaar of in strijd met de
  wet wordt bevonden, dan wordt de betreffende bepaling gewijzigd in de mate die minimaal vereist
  is om deze afdwingbaar te maken. De overige delen van deze Overeenkomst blijven volledig en
onverminderd van kracht.</li>
<li> Deze Overeenkomst en de Aanvullende Voorwaarden, indien van toepassing, vormen de volledige
  overeenkomst tussen de Klant en Sharp met betrekking tot de Diensten en vervangen alle eerdere
  of gelijktijdige afspraken en overeenkomsten, met inbegrip van aankooporders, hetzij
schriftelijk hetzij mondeling, met betrekking tot het onderwerp van deze Overeenkomst.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
